<template>
  <app-data-table design="new" density="dense" :rows="tickets" :columns="columns" :min-width="minWidth" :loading="loading">
    <template v-for="column in columns" #[`cell-${column.key}`]="{ row }">
      <slot :name="`cell-${column.key}`" :ticket="row">
        <AppTableText :text="row[column.key]" />
      </slot>
    </template>
  </app-data-table>
</template>

<script>
import AppTableText from '@/components/AppTableText.vue'

export default {
  name: 'SupportTicketTable',
  components: { AppTableText },
  props: {
    tickets: { type: Array, default: () => [] },
    columns: { type: Array, required: true },
    minWidth: { type: String, default: '1200px' },
    rowClass: { type: Function, default: null },
    loading: Boolean
  }
}
</script>
